import React, { useEffect, useState } from "react";
import moment from "moment";
import { policies } from "../apis/report";
import Loading from "../common/Loading";
import { useDispatch } from "react-redux";
import { showMessage } from "../modal/duck/actions";
import FormattedDecimal from "../common/FormattedDecimal";

const PolicyReport = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const dispatch = useDispatch();
    const goPolicyDetail = (policyId) => {
        if (!policyId) return;
        window.location.href = `https://crm.tcisigorta.com/policy-detail/${policyId}`;
    };
    const filteredData = (data || []).filter(item => {
        const q = (searchText || "").toLowerCase().trim();
        if (!q) return true;
        const account = (item.accountName || "").toLowerCase();
        const insurer = (item.currentInsurer || "").toLowerCase();
        const currency = (item.currentCurrency || "").toLowerCase();
        return account.includes(q) || insurer.includes(q) || currency.includes(q);
    });

    useEffect(() => {
        setLoading(true);
        policies()
            .then((res) => {
                if (!res.isSuccess) {
                    dispatch(showMessage((res.data || {}).message || "UnknownError"));
                    setData([]);
                    return;
                }
                setData(res.data || []);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="report-sales">
            {loading ? (
                <Loading className="medium" />
            ) : (
                <>
                    <div className="report-sales__timeline" style={{ height: "auto", padding: "1rem 2rem", marginBottom: "1rem" }}>
                        <input
                            type="text"
                            className="expense-general__input--text"
                            placeholder="Ara (Firma / Sigortacı / Döviz)"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                    <div className="invoices__header">
                        <div className="invoices__header-image"></div>
                        <div className="invoices__header-definition">Firma</div>
                        <div className="invoices__header-date middle">Baslangic</div>
                        <div className="invoices__header-date middle">Bitis</div>
                        <div className="invoices__header-date middle">Sigortaci</div>
                        <div className="invoices__header-amount middle">Prim</div>
                        <div className="invoices__header-button"></div>
                    </div>
                    <div className="invoices">
                        {filteredData.map((item, index) => (
                            <div className="invoices__item" key={`policy-row-${index}`}>
                                <div className="invoices__item-image" onClick={() => goPolicyDetail(item.currentPolicyId)} style={{ cursor: item.currentPolicyId ? "pointer" : "default" }}>
                                    <svg className="icon invoices__item-icon">
                                        <use xlinkHref="../img/sprite.svg#icon-file-text"></use>
                                    </svg>
                                </div>
                                <div className="invoices__item-definition">
                                    <div className="invoices__item-definition--top">
                                        <span className="invoices__item-definition--invoice-definition">
                                            {item.accountName}
                                        </span>
                                    </div>
                                    <div className="invoices__item-definition--bottom">
                                        <span className="invoices__item-definition--source">{item.currentCurrency}</span>
                                    </div>
                                </div>
                                <div className="invoices__item-date">
                                    <span className="invoices__item-date--date">
                                        {item.currentStarting ? moment(item.currentStarting).format("DD/MM/YYYY") : ""}
                                    </span>
                                </div>
                                <div className="invoices__item-date">
                                    <span className="invoices__item-date--date">
                                        {item.currentExpiry ? moment(item.currentExpiry).format("DD/MM/YYYY") : ""}
                                    </span>
                                </div>
                                <div className="invoices__item-date">
                                    <span className="invoices__item-date--date">{item.currentInsurer}</span>
                                </div>
                                <div className="invoices__item-amount">
                                    <FormattedDecimal className="invoices__item-amount--main" value={item.currentPremium || 0} abb="" />
                                </div>
                                <div className="invoices__item-button"></div>
                            </div>
                        ))}
                        {filteredData.length === 0 && (
                            <div className="invoices__item">
                                <div className="invoices__item-definition">
                                    <div className="invoices__item-definition--top">Sonuç bulunamadı</div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default PolicyReport;
